import { PopperProps } from '@mui/material'
import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import SvgReceiptAttached from 'src/components/Svgs/SvgReceiptAttached'
import SvgReceiptMissing from 'src/components/Svgs/SvgReceiptMissing'
import { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ReceiptsTooltipProps {
  count?: number
  placement: PopperProps['placement']
  isMissing?: boolean
}

const ReceiptsTooltip: React.FC<ReceiptsTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  let message
  if (props.count !== undefined) {
    message = translate(
      props.count === 1 ? '${count} receipt' : '${count} receipts',
      { count: props.count.toString() },
    )
  }
  if (props.isMissing) {
    message = translate('Receipt required')
  }

  return (
    <TooltipIcon
      placement={props.placement}
      icon={
        props.isMissing ? (
          <SvgReceiptMissing
            css={css`
              transform: scale(calc(20 / 24));
            `}
          />
        ) : (
          <SvgReceiptAttached
            css={css`
              transform: scale(calc(20 / 24));
            `}
          />
        )
      }
      iconTestId={
        props.isMissing ? 'missingReceiptsIcon' : 'receiptsAttachedIcon'
      }
    >
      {message}
    </TooltipIcon>
  )
}

export default ReceiptsTooltip
